import React, { useRef, useState, useEffect } from 'react';

import { MdOutlineDragIndicator} from "react-icons/md";
import { GiHorizontalFlip, GiVerticalFlip } from "react-icons/gi";
import InsertPeakIcon from '../images/toolsSVG/InserPeakIcon';
import EditBaselineIcon from '../images/toolsSVG/EditBaselineIcon';
import SplitPeakIcon from '../images/toolsSVG/SplitPeakIcon';
import DeletePeakIcon from '../images/toolsSVG/DeletePeakIcon';
import ShapeShoulderIcon from '../images/toolsSVG/ShapeShoulderIcon';







const Toolbox = ({
  tools = [
    { icon: <EditBaselineIcon />, label: 'Edit Baseline' },
    { icon: <InsertPeakIcon />, label: 'Insert Peak' },
    { icon: <SplitPeakIcon />, label: 'Split Peak' },
    { icon: <DeletePeakIcon />, label: 'Delete Peak' },
    { icon: <ShapeShoulderIcon />, label: 'Shape Shoulder' }
  ],
  floating = true,
  initialLayout = 'horizontal',
}) => {
  const boxRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [layout, setLayout] = useState(initialLayout);
  const [tooltipPosition, setTooltipPosition] = useState('right');
  const [isReady, setIsReady] = useState(false);
  const [canDiscard, setCanDiscard] = useState(false);
  const [canDiscardDeletes, setCanDiscardDeletes] = useState(false);
  const [canDiscardInserts, setCanDiscardInserts] = useState(false);
  const [canDiscardSplits, setCanDiscardSplits] = useState(false);
  const [deletePeakMode, setDeletePeakMode] = useState('single'); // 'single' or 'convoluted'
  const EDIT_BASELINE_LABEL = 'Edit Baseline';
  const DELETE_PEAK_LABEL = 'Delete Peak';
  const INSERT_PEAK_LABEL = 'Insert Peak';
  const SPLIT_PEAK_LABEL = 'Split Peak';
  const isEditing = selectedIndex !== null && tools[selectedIndex]?.label === EDIT_BASELINE_LABEL;
  const isDeleting = selectedIndex !== null && tools[selectedIndex]?.label === DELETE_PEAK_LABEL;
  const isInserting = selectedIndex !== null && tools[selectedIndex]?.label === INSERT_PEAK_LABEL;
  const isSplitting = selectedIndex !== null && tools[selectedIndex]?.label === SPLIT_PEAK_LABEL;

  const fireBaselineAction = (action) => {
    try { window.dispatchEvent(new CustomEvent('baseline-action', { detail: { action } })); } catch {}
  };

  const fireDeletePeakAction = (action) => {
    try { 
      window.dispatchEvent(new CustomEvent('delete-peak-action', { detail: { action } })); 
    } catch {}
  };

  const fireDeletePeakModeChange = (mode) => {
    try {
      window.dispatchEvent(new CustomEvent('delete-peak-mode-change', { detail: { mode } }));
    } catch {}
  };

  const fireInsertPeakAction = (action) => {
    try {
      window.dispatchEvent(new CustomEvent('insert-peak-action', { detail: { action } }));
    } catch {}
  };

  const fireSplitPeakAction = (action) => {
    try {
      window.dispatchEvent(new CustomEvent('split-peak-action', { detail: { action } }));
    } catch {}
  };

  useEffect(() => {
    setTimeout(() => {
      // const toolbox = boxRef.current;
      // const toolboxWidth = toolbox?.offsetWidth || 150;
      const centerX = window.innerWidth / 2 -75;
      const centerY = 10;
      setPosition({ x: centerX, y: centerY });
      setIsReady(true);
    }, 0);
  }, []);

  useEffect(() => {
    const onHistoryState = (e) => {
      const { canDiscard } = e.detail || {};
      // console.log('Toolbox: baseline-history-state received, canDiscard:', canDiscard);
      setCanDiscard(!!canDiscard);
    };
    const onEditToggle = (e) => {
      const { enabled } = e.detail || {};
      // console.log('Toolbox: baseline-edit-mode received, enabled:', enabled);
      if (!enabled) setCanDiscard(false);
    };
    const onDeletePeakHistoryState = (e) => {
      const { canDiscard } = e.detail || {};
      setCanDiscardDeletes(!!canDiscard);
    };
    const onDeletePeakToggle = (e) => {
      const { enabled } = e.detail || {};
      // console.log('Toolbox: delete-peak-mode received, enabled:', enabled);
      if (!enabled) {
        setCanDiscardDeletes(false);
        setDeletePeakMode('single'); // Reset to default when disabled
      }
    };
    const onInsertPeakHistoryState = (e) => {
      const { canDiscard } = e.detail || {};
      setCanDiscardInserts(!!canDiscard);
    };
    const onInsertPeakToggle = (e) => {
      const { enabled } = e.detail || {};
      if (!enabled) {
        setCanDiscardInserts(false);
      }
    };
    const onSplitPeakHistoryState = (e) => {
      const { canDiscard } = e.detail || {};
      setCanDiscardSplits(!!canDiscard);
    };
    const onSplitPeakToggle = (e) => {
      const { enabled } = e.detail || {};
      if (!enabled) {
        setCanDiscardSplits(false);
      }
    };
    try { window.addEventListener('baseline-history-state', onHistoryState); } catch {}
    try { window.addEventListener('baseline-edit-mode', onEditToggle); } catch {}
    try { window.addEventListener('delete-peak-history-state', onDeletePeakHistoryState); } catch {}
    try { window.addEventListener('delete-peak-mode', onDeletePeakToggle); } catch {}
    try { window.addEventListener('insert-peak-history-state', onInsertPeakHistoryState); } catch {}
    try { window.addEventListener('insert-peak-mode', onInsertPeakToggle); } catch {}
    try { window.addEventListener('split-peak-history-state', onSplitPeakHistoryState); } catch {}
    try { window.addEventListener('split-peak-mode', onSplitPeakToggle); } catch {}
    return () => {
      try { window.removeEventListener('baseline-history-state', onHistoryState); } catch {}
      try { window.removeEventListener('baseline-edit-mode', onEditToggle); } catch {}
      try { window.removeEventListener('delete-peak-history-state', onDeletePeakHistoryState); } catch {}
      try { window.removeEventListener('delete-peak-mode', onDeletePeakToggle); } catch {}
      try { window.removeEventListener('insert-peak-history-state', onInsertPeakHistoryState); } catch {}
      try { window.removeEventListener('insert-peak-mode', onInsertPeakToggle); } catch {}
      try { window.removeEventListener('split-peak-history-state', onSplitPeakHistoryState); } catch {}
      try { window.removeEventListener('split-peak-mode', onSplitPeakToggle); } catch {}
    };
  }, []);

  if (!isReady) return null;

  const handleMouseDown = (e) => {
    if (!floating) return;

    document.body.style.userSelect = 'none';

    const startX = e.clientX;
    const startY = e.clientY;
    const startLeft = position.x;
    const startTop = position.y;

    const handleMouseMove = (e) => {
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      const toolbox = boxRef.current;
      const toolboxWidth = toolbox?.offsetWidth || 150;
      const toolboxHeight = toolbox?.offsetHeight || 150;
      const maxX = window.innerWidth - toolboxWidth;
      const maxY = window.innerHeight - toolboxHeight;

      const newX = Math.min(Math.max(startLeft + dx, 0), maxX);
      const newY = Math.min(Math.max(startTop + dy, 0), maxY);

      setPosition({ x: newX, y: newY });
      if (layout === 'vertical') {
        setTooltipPosition(newX > window.innerWidth / 2 ? 'left' : 'right');
      } else {
        setTooltipPosition(newY > window.innerHeight / 2 ? 'top' : 'bottom');
      }
    };

    const handleMouseUp = () => {
      document.body.style.userSelect = '';
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div
      ref={boxRef}
      onMouseDown={(e) => e.target.closest('.drag-handle') && handleMouseDown(e)}
      className={`fixed z-50 bg-white shadow-lg border rounded-lg p-2  ${
        layout === 'horizontal' ? 'flex-row' : 'flex-col'
      } flex gap-2`}
      style={{ left: position.x, top: position.y,  }}
    >
      <div className="drag-handle cursor-move text-gray-300 hover:text-gray-500 transition-all flex items-center justify-center">
        <MdOutlineDragIndicator size={26} />
        </div>
        
      <button
        onClick={() => setLayout(layout === 'vertical' ? 'horizontal' : 'vertical')}
        className="p-2 rounded relative group flex flex-col items-center hover:bg-gray-100 active:bg-gray-200"
      >
        <span className="text-gray-500 group-hover:text-black transition-colors">
            {layout === 'vertical' ? <GiHorizontalFlip size={23} /> : <GiVerticalFlip size={23} />}
        </span>
        <span className={`
          ${
            layout === 'vertical'
              ? tooltipPosition === 'left'
                ? 'absolute right-full mr-2 top-1/2 -translate-y-1/2'
                : 'absolute left-full ml-2 top-1/2 -translate-y-1/2'
              : tooltipPosition === 'top'
                ? 'absolute bottom-full mb-2 left-1/2 -translate-x-1/2'
                : 'absolute top-full mt-2 left-1/2 -translate-x-1/2'
          }
          whitespace-nowrap text-xs bg-gray-500 text-white px-2 py-1 rounded 
          opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none
        `}>
          {layout === 'vertical' ? 'Switch to Horizontal' : 'Switch to Vertical'}
        </span>
      </button>
      {tools.map(({ icon, label }, idx) => (
        <button
          key={idx}
          onClick={() => {
            const next = selectedIndex === idx ? null : idx;
            setSelectedIndex(next);
            const baselineEnabled = next !== null && (tools[next]?.label === EDIT_BASELINE_LABEL);
            const deletePeakEnabled = next !== null && (tools[next]?.label === DELETE_PEAK_LABEL);
            const insertPeakEnabled = next !== null && (tools[next]?.label === INSERT_PEAK_LABEL);
            const splitPeakEnabled = next !== null && (tools[next]?.label === SPLIT_PEAK_LABEL);
            try {
              window.dispatchEvent(new CustomEvent('baseline-edit-mode', { detail: { enabled: baselineEnabled } }));
              window.dispatchEvent(new CustomEvent('delete-peak-mode', { detail: { enabled: deletePeakEnabled } }));
              window.dispatchEvent(new CustomEvent('insert-peak-mode', { detail: { enabled: insertPeakEnabled } }));
              window.dispatchEvent(new CustomEvent('split-peak-mode', { detail: { enabled: splitPeakEnabled } }));
            } catch {}
          }}
          className={`p-2 rounded relative group flex flex-col items-center ${selectedIndex === idx ? 'bg-gray-200' : 'hover:bg-gray-100 active:bg-gray-200'}`}
        >
          <span className={`transition-colors w-6 h-6 ${selectedIndex === idx ? 'text-white' : 'text-gray-500 group-hover:text-black'}`}>
            {icon}
          </span>
          <span className={`
            ${
              layout === 'vertical'
                ? tooltipPosition === 'left'
                  ? 'absolute right-full mr-2 top-1/2 -translate-y-1/2'
                  : 'absolute left-full ml-2 top-1/2 -translate-y-1/2'
                : tooltipPosition === 'top'
                  ? 'absolute bottom-full mb-2 left-1/2 -translate-x-1/2'
                  : 'absolute top-full mt-2 left-1/2 -translate-x-1/2'
            }
            whitespace-nowrap text-xs bg-gray-500 text-white px-2 py-1 rounded 
            opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none
          `}>
            {label}
          </span>
        </button>
      ))}

      {isDeleting && (
        <div className={`flex ${layout === 'horizontal' ? 'flex-row' : 'flex-col'} gap-2 pl-2 ml-1 border-l`}>
          <button
            onClick={() => {
              setDeletePeakMode('single');
              fireDeletePeakModeChange('single');
            }}
            className={`px-2 py-1 text-xs rounded border transition-colors ${
              deletePeakMode === 'single'
                ? 'bg-blue-100 text-blue-700 border-blue-300 font-semibold'
                : 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100'
            }`}
            aria-label="Delete single peaks"
            title="Delete single peaks individually"
          >
            Single
          </button>
          <button
            onClick={() => {
              setDeletePeakMode('convoluted');
              fireDeletePeakModeChange('convoluted');
            }}
            className={`px-2 py-1 text-xs rounded border transition-colors ${
              deletePeakMode === 'convoluted'
                ? 'bg-blue-100 text-blue-700 border-blue-300 font-semibold'
                : 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100'
            }`}
            aria-label="Delete convoluted peaks"
            title="Delete all convoluted peaks together"
          >
            Convoluted
          </button>
        </div>
      )}

      {isEditing && canDiscard && (
        <div className={`flex ${layout === 'horizontal' ? 'flex-row' : 'flex-col'} gap-2 pl-2 ml-1 border-l` }>
          <button
            onClick={() => fireBaselineAction('discard')}
            className="px-2 py-1 text-xs rounded border bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
            aria-label="Discard baseline changes"
          >
            Discard
          </button>
        </div>
      )}

      {isDeleting && canDiscardDeletes && (
        <div className={`flex ${layout === 'horizontal' ? 'flex-row' : 'flex-col'} gap-2 pl-2 ml-1 border-l` }>
          <button
            onClick={() => fireDeletePeakAction('discard')}
            className="px-2 py-1 text-xs rounded border bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
            aria-label="Discard peak deletions"
          >
            Discard
          </button>
        </div>
      )}

      {isInserting && canDiscardInserts && (
        <div className={`flex ${layout === 'horizontal' ? 'flex-row' : 'flex-col'} gap-2 pl-2 ml-1 border-l` }>
          <button
            onClick={() => fireInsertPeakAction('discard')}
            className="px-2 py-1 text-xs rounded border bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
            aria-label="Discard peak insertions"
          >
            Discard
          </button>
        </div>
      )}

      {isSplitting && canDiscardSplits && (
        <div className={`flex ${layout === 'horizontal' ? 'flex-row' : 'flex-col'} gap-2 pl-2 ml-1 border-l` }>
          <button
            onClick={() => fireSplitPeakAction('discard')}
            className="px-2 py-1 text-xs rounded border bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
            aria-label="Discard peak splits"
          >
            Discard
          </button>
        </div>
      )}
    </div>
  );
};

export default Toolbox;